import React from "react";
import Translation from "../i18n";

class Footer extends React.Component {

    render() {
        return (
            <div className="container-fluid px-0 bg-primary footer">
                <div className="container py-4 text-center">
                    <a href="https://www.soulsteps.at" target="_blank" rel="noreferrer" className="link-light mx-3">
                        <Translation i18n="contact" />
                    </a>
                    <a href="https://www.soulsteps.at" target="_blank" rel="noreferrer" className="link-light mx-3">
                        <Translation i18n="terms" />
                    </a>
                    <a href="https://www.soulsteps.at" target="_blank" rel="noreferrer" className="link-light mx-3">
                        <Translation i18n="privacy" />
                    </a>
                </div>
            </div>
        );
    }
}

export default Footer;
